export class CornerDTO {
  public id?: number;
  public uuid: string;

  public x: number;
  public y: number;
  public z: number;

  public height: number;

  constructor(uuid: string, x: number, y: number, z: number, height: number, id?: number) {
    this.id = id;
    this.uuid = uuid;

    this.x = x;
    this.y = y;
    this.z = z;

    this.height = height;
  }
}
